const T = require('prop-types');

module.exports = {
    defaultInterestId: T.number,
    showNotification: T.func,
    onSubmit: T.func.isRequired,
    onSubmitNoRedirect: T.func.isRequired,
    onInvalidSubmit: T.func.isRequired,
    interestsLoading: T.bool.isRequired,
    officesLoading: T.bool.isRequired,
    yearsHiredLoading: T.bool.isRequired,
    preferencesLoading: T.bool,
    saveProfileProgress: T.func,
    saveProfilePicture: T.func,
    savePreferencesProgress: T.func,
    badges: T.arrayOf(T.shape({
        id: T.number,
        name: T.string,
        svg: T.string,
        icon: T.any,
        label: T.string,
        userPermissions: T.string
    })),
    transfers: T.array,
    offCampusHousingList: T.array,
    onCampusHousingList: T.array,
    majors: T.array,
    departments: T.arrayOf(
        T.shape({
            id: T.number,
            name: T.string
        })
    ),
    officesList: T.arrayOf(
        T.shape({
            id: T.number,
            name: T.string
        })
    ),
    yearsHiredList: T.arrayOf(
        T.shape({
            id: T.number,
            year: T.number
        })
    ),
    incomingClassList: T.array,
    graduatingClassList: T.array,
    signupDetails: T.shape({
        type: T.string,
        picFile: T.object,
        cropPosition: T.shape({ x: T.number, y: T.number }),
        cropRotation: T.number,
        cropScale: T.number,
        picPreviewURL: T.string,
        croppedPicture: T.string,
        firstName: T.string,
        lastName: T.string,
        birthdate: T.date,
        majorId: T.number,
        departmentId: T.number,
        officeId: T.number,
        yearHiredId: T.number,
        workRemote: T.bool,
        title: T.string,
        hometown: T.shape({
            id: T.number,
            placeId: T.string,
            name: T.string,
            onCampus: T.bool
        }),
        incomingClass: T.string,
        graduatingClass: T.string,
        career: T.string,
        profession: T.string,
        interests: T.array,
        passionInterests: T.array,
        bio: T.string,
        studentBio: T.string,
        studentName: T.string,
        housing: T.shape({
            id: T.number,
            placeId: T.string,
            name: T.string,
            onCampus: T.bool
        }),
        role: T.shape({
            id: T.number,
            name: T.string,
            label: T.string
        }),
        transfer: T.object,
        veteran: T.any, // Might be string or bool
        parent: T.bool,
        onlineStudent: T.bool,
        openToSocial: T.any, // Might be string or bool
        fullTime: T.any, // Might be string or bool
        gender: T.string,
        ethnicity: T.string,
        introExtroLevel: T.number,

        // Here for the linter, these do not get passed in
        genderText: T.string,
        ethnicityText: T.string,
        preferences: T.object
    }),
    isParent: T.bool,
    // isStudentRoleGroup: T.bool,
    rolePermissions: T.shape({
        id: T.number,
        roleId: T.number,
        schoolId: T.number,
        homeText: T.string,
        canEditAge: T.bool,
        canEditMajor: T.bool,
        canEditHomeTown: T.bool,
        canEditCareerAspiration: T.bool,
        canEditProfession: T.bool,
        canEditDepartment: T.bool,
        canEditBadge: T.bool,
        canEditTitle: T.bool,
        canEditIncomingClass: T.bool,
        canEditGraduatingClass: T.bool,
        canEditBio: T.bool,
        canEditLiveOnCampus: T.bool,
        canEditTransfer: T.bool,
        canEditVeteran: T.bool,
        canEditOnline: T.bool,
        canEditParent: T.bool,
        canEditOpenSocial: T.bool,
        canEditTimeStatus: T.bool,
        canEditStudentName: T.bool,
        canEditStudentBio: T.bool,
        canEditYearHired: T.bool,
        canEditOffice: T.bool,
        canEditWorkRemote: T.bool,
        includeEthnicity: T.bool,
        profilePicRequired: T.bool,
        includePronouns: T.bool,
        canEditIntroExtro: T.bool
    }),
    role: T.shape({
        id: T.number,
        name: T.string,
        label: T.string
    }),
    mode: T.oneOf(['signup', 'edit']),
    isCompany: T.bool,
    isCommunity: T.bool,
    isSchoolOnline: T.bool,
    location: T.object,
    fieldsPlaceholders: T.shape({
        bio: T.string
    }),
    useProfanityFilter: T.bool,
    initialState: T.object,
    schema: T.object,
    children: T.func
};
